import './App.css';
import Main from './components/MainComponent';

function App() {
  return (
      <div className="body">
        <Main />
      </div>
  );
}

export default App;
